var path = '/configuration/formEditor/content/preview/formPreview.tpl.html';
var html = "<div class=\"\">form preview</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;